export enum MemberType { 
    Family=1,
    NonFamily=2,
}